interface Props {
  timestamp?: string;
  version?: string;
}

const ChangelogLabel = (props: Props) => {
  const { timestamp, version } = props;

  if (!timestamp && !version) {
    return null;
  }

  return (
    <div className="changelog-label">
      <span className="changelog-label__version">{version}</span>
      <span className="changelog-label__timestamp">{timestamp}</span>
    </div>
  );
};

export default ChangelogLabel;
